import { HisRule, SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class HisRowParser_疲勞狀況 {

  static ConvertToHisRow(func_guid: string, step: SpwkHisStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): HisRow {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_疲勞狀況) {
      throw new Error("6849132 必須是 CHAPTER_疲勞狀況 !!!");
    }

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_疲勞狀況);

    if (q_meta_list.length !== 13) {
      throw new Error("89461 應該是13題疲勞問卷 !!!");
    }

    /* 確認是13題疲勞問卷題目，且為 1~13 */
    let q_idx = 1;
    for (const q_meta of q_meta_list) {
      if (q_meta.q_his_rule !== HisRule.Tired) {
        throw new Error("1684663 A98疲勞狀況，不應該有其他 q_his_rule !!!\ndata_guid:" + q_meta.data_guid);
      }

      if (q_meta.his_code !== ("" + q_idx)) {
        throw new Error("643153 題目順序錯誤 q_idx='" + q_idx + "' !!!\ndata_guid:" + q_meta.data_guid);
      }

      q_idx++;
    }

    const data_row: HisRow = new HisRow(基本檔, step.HIS類別代碼);
    data_row.類別 = "6";// 總是集中在一題 //yao這裡可能也要改
    data_row.項目 = "1"
    let his_code_list: string[] = [];
    for (const q_meta of q_meta_list) {
      let rslt = meta_table.GetRadioOption_HisCodeBundle(q_meta);
      his_code_list.push(rslt.his_code); // 總是=10000, 常常=01000, 有時候=00100, 不常=00010, 從未或幾乎從未=00001
    }

    data_row.結果 = his_code_list.join(",");// 範例: 00001,00010,00010,00001,00010,00001,00001,00001,00001,00001,00001,00001,00100


    return data_row;
  }


}